export default __webpack_public_path__ + "static/media/icons8-time-48.b7718d87.svg";